import { __assign, __rest } from "tslib";
import React from 'react';
import CommentContextProvider from './_partials/CommentContext';
import CommentContent from './_partials/CommentContent';
import LoadableCommentReduxModule from './LoadableCommentReduxModule';
export var Comment = function (_a) {
    var comment = _a.comment, onEditingStateChange = _a.onEditingStateChange, props = __rest(_a, ["comment", "onEditingStateChange"]);
    return (React.createElement(CommentContextProvider, { comment: comment, onEditingStateChange: onEditingStateChange },
        React.createElement(LoadableCommentReduxModule, null),
        React.createElement(CommentContent, __assign({}, props))));
};
Comment.displayName = 'Comment';
Comment.defaultProps = {
    canPostComment: true,
};
export default Comment;
//# sourceMappingURL=Comment.js.map